<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.SelectCopyContent')"
    width="400px"
    :close-on-click-modal="false"
  >
    <div>
      <el-form label-position="left">
        <el-form-item :label="''">
          <el-radio-group v-model="listType" no="1">
            <el-radio :label="0">{{ $t('SystemMaintenance.BookingSuccessful') }}</el-radio>
            <el-radio :label="1">{{ $t('SeaExport.ToBeConfirmed') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="''">
          <el-input
            v-model="note"
            no="2"
            type="textarea"
            :rows="10"
            style="width: 285px;"
          />
        </el-form-item>
        <el-form-item :label="''">
          <el-radio-group v-model="fillType" no="3">
            <el-radio :label="0">{{ $t('CargoMsg.Cargo_FillSO') }}</el-radio>
            <el-radio :label="1">{{ $t('CargoMsg.Cargo_FillMBL') }}</el-radio>
            <el-radio :label="2">{{ $t('CargoMsg.Cargo_FillALL') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div style="margin-left: 24px;font-size: 12px;-webkit-font-smoothing: antialiased;text-rendering: optimizeLegibility;font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;">
        <label>{{ $t('Message.CopyNumber') }}</label>
        <el-input-number no="CopyNumber" :value="copyNum" :precision="0" :min="1" :max="100" controls-position="right" style="width: 100px;" @input="numFunction" />
      </div>
    </div>
    <span slot="footer">
      <el-button no="confirm" type="primary" @click="enterHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'CopyWindow',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    source: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      fullscreenLoading: false,
      listType: 0,
      fillType: 0,
      note: '',
      copyNum: 1
    }
  },
  computed: {},
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    enterHandler() {
      if (this.listType === 0) {
        // 订舱成功填写MBL or SO
        if (!this.note) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_checkTip2', ['S/O', 'MBL']))
          return
        }
        const list = this.note.split('\n')
        if (list.length < this.copyNum) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_checkTip2', ['S/O', 'MBL']))
          return
        }
      }
      this.$emit('copy', { data: this.source, 'copyNum': this.copyNum, 'listType': this.listType, 'fillType': this.fillType, 'note': this.note })
      this.close()
    },
    numFunction(val) {
      if (typeof val === 'undefined') {
        this.copyNum = NaN
        this.$nextTick(function() {
          this.copyNum = 1
        })
      } else {
        this.copyNum = val
      }
    },
    close() {
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
